import { SxProps } from '@mui/material';
import styled from 'styled-components';
import { PageTitle } from '../../design_system/texts';
import { Input as BaseInput, Flex, Text } from '../../legacy/style';

export const Title = styled(PageTitle)`
    margin: '24px 6px 24px';
`;

export const Input = styled(BaseInput)`
    outline: 1px solid ${({ theme }) => theme.color.grey.light};
    width: 100%;
    box-sizing: border-box;

    &:focus {
        outline: 2px solid ${({ theme }) => theme.color.blue.primary};
    }
`;

export const EmptySession = styled(Flex).attrs({ column: true })`
    height: 100%;
`;

export const TextInformation = styled(Text).attrs({ size: '18px' })`
    line-height: 1;
`;

export const SessionUsername = styled(Text).attrs({ size: '14px' })`
    font-weight: 500;
    line-height: 20px;
    color: ${({ theme }) => theme.color.blue.dark};
`;

export const OrganizationName = styled(Text).attrs({ size: '14px' })`
    font-weight: 400;
    line-height: 20px;
    color: ${({ theme }) => theme.color.grey.light};
`;

export const tooltipCell: SxProps = {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.43,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
